module.exports = __webpack_public_path__ + "img/OBUNoOrder_01.31c7d918.png";